
import { defineStore } from 'pinia';

export const useLocaleStore = defineStore('localeStore', {

    state: () => {
        return {
            locale: 'bn'
        }
    },
    actions: {
        setLocale(locale) {
            this.locale = locale;
            localStorage.setItem('locale', locale); 
        },
        init() {
            this.locale = localStorage.getItem('locale')|| 'bn';
        }
    },

    
});
